"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var ResultHeaderIllustration = function ResultHeaderIllustration(props) {
  return _react.default.createElement("div", {
    className: "result-header-illustration"
  }, _react.default.createElement(_UIIllustration.default, (0, _extends2.default)({}, props, {
    width: "150px"
  })));
};

var _default = ResultHeaderIllustration;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/ResultHeaderIllustration.js
// module id = 66
// module chunks = 0